// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Ph_G","title":"Header_title__1uFnx","left":"Header_left__Pd2ER","clinicName":"Header_clinicName__3QP_z"};